$(document).ready(function(){
    App.vue.init();
    require('./global');
});